// import { beforeEnter, beforeEnterCreate, beforeEnterUpdate, } from "./beforeEnter";

export default {
    path: 'permission-group',
    component: () => import('../PermissionGroup.vue'),
    // beforeEnter,
    children: [
        {
            path: '',
            name: 'Danh sách nhóm phân quyền',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo danh sách nhóm phân quyền',
            component: () => import('../cu/CU.vue'),
            // beforeEnter: beforeEnterCreate
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa nhóm phân quyền',
            component: () => import('../cu/CU.vue'),
            // beforeEnter: beforeEnterUpdate
        },
    ]
};